﻿import { IGOMAveragesSetStation } from "../API/GOMAverages/GOMAveragesSet";
import { LiveDataSetStation, Status } from "../API/LiveData/LiveDataSet";
import { ParameterDefinition } from "../Model/ParameterDefinition";
import { WarningGroup } from "../Model/WarningGroup";
import { ParameterGroupInfo } from "../ParameterGroupInfoSet";

export interface IStationValueFormatter {
    format(liveDataSetStation: LiveDataSetStation | IGOMAveragesSetStation, warningGroup?: WarningGroup): IStationValueObject;
    getShortName(): string;
    getUnits(): string;
    getDescription(): string;
    getId(): string;
    getSensorId(): string;
    getParameterGroupInfo(): ParameterGroupInfo | null;
    plottable(): boolean;
    axisMin(): number;
    axisMax(): number;
    plotLines(): boolean;
}

export interface IStationValueObject {
    Value: string;
    Status: Status;
    WarningThreshold: WarningThreshold;
    ParameterDefinition: ParameterDefinition;
    Timestamp: number;
    Sensor: string;
}

export enum WarningThreshold {
    OK,
    Level1,
    Level2,
    Level3
}